<template>
  <div v-html="params.value" />
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'CellGridRichText'
})
</script>

<style scoped>
    div p {
        margin-bottom: .5rem;
    }
    div {
        height: 100%;
    }
</style>
